<template>
  <v-sheet
    class="uploadComponent"
    title="Click to grap a file from your PC!"
    :color="dragover ? 'gray lighten-2' : 'white darken-4'"
    width="100%"
  >
    <input
      ref="upload"
      id="fileUpload"
      type="file"
      :accept="accept"
      :multiple="false"
      style="display:none"
    />
    <v-container
      ref="dzone"
      id="dropzone"
      tabindex="0"
      style="cursor:pointer;"
      class="pa-4 uploadZone"
    >
      <v-row justify="center">
        <v-icon v-if="!dragover" color="purple darken-2" size="75"
          >mdi-cloud-upload-outline</v-icon
        >
        <v-icon v-if="dragover" color="purple darken-2" size="75"
          >mdi-cloud-upload</v-icon
        >
      </v-row>
      <v-row class="ma-4" justify="center">
        <span class="title purple--text text--darken-2">{{ displayText }}</span>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  props: {
    displayText: {
      type: String,
      default: "Drag'n drop or click to upload file!"
    },
    numberFormat: {
      type: String,
      default: "en-EN"
    },
    accept: {
      type: String,
      default: ".csv"
    },
    maxFileSize: {
      type: Number,
      default: 2 /* <= Size in Megabytes */
    }
  },
  data: () => ({
    dragover: false,
    formUpload: false,
    files: [],
    maxFilesReached: false,
    errorFiles: []
  }),
  methods: {
    removeFile(index) {
      this.maxFilesReached = false;
      this.files.splice(index, 1);
    },
    isFileSizeLimit(size) {
      return size > this.maxFileSize * 1024 * 1024;
    },
    getFileSize(size) {
      const kb = size / 1024;
      const mb = kb / 1024;

      if (kb < 1024) {
        return (
          new Intl.NumberFormat(this.numberFormat, {
            maximumSignificantDigits: 3
          }).format(kb) + " KB"
        );
      } else {
        return (
          new Intl.NumberFormat(this.numberFormat, {
            maximumSignificantDigits: 3
          }).format(mb) + " MB"
        );
      }
    },
    filesSelected(fileList) {
      this.dragover = false;
      //if append mode is off, clear the files array
      this.$emit("filesSelected", fileList);
    }
  },
  computed: {
    getTotalSize() {
      let size = 0;
      for (let file of this.files) {
        if (file.origFile) {
          size += file.origFile.size;
        }
      }
      return size;
    }
  },

  mounted() {
    const dropzone = this.$refs.dzone;
    const fileupload = this.$refs.upload;

    // register listeners on your dropzone / v-sheet
    if (dropzone) {
      //File input change event
      fileupload.addEventListener("change", e => {
        e.preventDefault();
        //Clear files array on appendMode = false or multiple = false or autoUpload = true

        this.files = [];

        //Add files to global files array
        this.filesSelected(e.target.files);
      });

      //Click event
      dropzone.addEventListener("click", e => {
        e.preventDefault();
        if (fileupload) {
          fileupload.click();
        }
      });

      dropzone.addEventListener("keypress", e => {
        e.preventDefault();
        if (e.key === "Enter") {
          if (fileupload) fileupload.click();
        }
      });

      // register all drag & drop event listeners
      dropzone.addEventListener(
        "dragenter",
        e => {
          e.preventDefault();
          this.dragover = true;
        },
        false
      );
      dropzone.addEventListener(
        "dragleave",
        e => {
          e.preventDefault();
          this.dragover = false;
        },
        false
      );
      dropzone.addEventListener(
        "dragover",
        e => {
          e.preventDefault();
          this.dragover = true;
        },
        false
      );
      dropzone.addEventListener(
        "drop",
        e => {
          e.preventDefault();
          if (e.dataTransfer) {
            //Clear files array on appendMode = false or multiple = false or autoUpload = true
            this.files = [];
            var items = e.dataTransfer.items;
            if (items.length > 0) {
              if (items[0].kind === "file") {
                this.filesSelected([items[0].getAsFile()]);
              }
            }
          }
        },
        false
      );
    }
  }
};
</script>

<style scoped>
.uploadComponent {
  padding: 5px !important;
  border: 1px solid #ddd !important;
  border-radius: 5px !important;
}
.uploadZone {
  border: 2px dashed gray !important;
}

.filesizeLimit {
  background-color: rgba(255, 100, 100, 0.9);
}
</style>
